import { render, staticRenderFns } from "./PrimaryWholesaleDetail.vue?vue&type=template&id=5b58c566&scoped=true&"
import script from "./PrimaryWholesaleDetail.vue?vue&type=script&lang=ts&"
export * from "./PrimaryWholesaleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryWholesaleDetail.vue?vue&type=style&index=0&id=5b58c566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58c566",
  null
  
)

export default component.exports